/**
 * Service layer — Vicinity Map generation (api/vicinity-map.js)
 *
 * Replaces the manual screenshot-Google-Maps workflow. Callers resolve the project's address
 * (getProjectAddressForVicinityMap) to prefill a confirm/edit prompt, then generate the styled
 * map image (generateVicinityMapImage) and feed the returned Blob into uploadTemplateImage
 * (services/templateImages.js) exactly like a manual upload.
 */

async function clerkToken() {
  return window.__clerkGetToken ? await window.__clerkGetToken() : null
}

/** Returns the project's composed address ("street, city, state zip"), or '' if unavailable. */
export async function getProjectAddressForVicinityMap(projectId) {
  const res = await fetch('/api/vicinity-map?projectId=' + encodeURIComponent(projectId), {
    headers: { Authorization: 'Bearer ' + await clerkToken() },
  })
  const d = await res.json()
  if (!res.ok) throw new Error(d.error || 'Failed to resolve project address')
  return d.address || ''
}

/** TRUE NORTH round (Modeler site settings): geocode an arbitrary typed address —
 *  one Mapbox call, { lat, lng, placeName }. Throws when the address can't resolve. */
export async function geocodeAddress(address) {
  const res = await fetch('/api/vicinity-map?geocode=1&address=' + encodeURIComponent(address), {
    headers: { Authorization: 'Bearer ' + await clerkToken() },
  })
  const d = await res.json()
  if (!res.ok) throw new Error(d.error || 'Address not found')
  return { lat: d.lat, lng: d.lng, placeName: d.placeName || address }
}

/** Geocodes the address and renders a styled static map with a site pin. Returns a PNG Blob. */
export async function generateVicinityMapImage(address, zoom) {
  const res = await fetch('/api/vicinity-map', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + await clerkToken() },
    body: JSON.stringify({ address, zoom }),
  })
  if (!res.ok) {
    let message = 'Failed to generate map'
    try { message = (await res.json()).error || message } catch { /* non-JSON error body */ }
    throw new Error(message)
  }
  return res.blob()
}
